import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/redux';

// A platform login passes through here just like an admin does — it still lands in the same
// DashboardLayout/sidebar, since Reports and Transactions already scope themselves to just that
// platform's own data server-side (type === 'platform' branches throughout ReportsService). Only
// the genuinely admin-only sections (Administration, Vendor/Platform Management, the
// cross-platform Billing pages) stay behind AdminRoute inside that same tree — see App.tsx.
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
